import React from "react";
import { useTranslation } from "react-i18next";
import { EntitySelectField } from "../../../../general/fields/modules/commons/entitySelectField/entitySelectField";
import { relationSchema } from "../../../../relation/domain/models/RelationModel";

interface DealerSelectSectionProps {
  relations: { id: string; name: string }[];
  selectedRelation: string | null;
  onRelationChange: (id: string) => void;
}

export const DealerSelectSection: React.FC<DealerSelectSectionProps> = ({
  relations,
  selectedRelation,
  onRelationChange,
}) => {
  const { t } = useTranslation("common");

  let input: React.ReactNode;
  if (relations.length === 1) {
    input = (
      <div className="form-control-plaintext fw-bold">{relations[0].name}</div>
    );
  } else {
    input = (
      <EntitySelectField
        entity={"Relation"}
        prefix={"relations"}
        onChange={(option) => {
          if (option && typeof option === "object" && "value" in option) {
            onRelationChange(option.value as string);
          }
        }}
        limit={50}
        clearable={true}
        schema={relationSchema}
        value={selectedRelation}
      />
    );
  }

  return (
    <div className="mt-3">
      <label>{t("For what dealer would you like to make the request?")}</label>
      {input}
    </div>
  );
};
